import React from 'react'

import withRenderModal from 'hocs/withRenderModal'
import Button from 'atoms/Button'
import Typography from 'atoms/Typography'
import Modal from 'molecules/Modal'

type WarningModalProps = {
  data: { message: string },
  closeModal: () => void,
}

const WarningModal = ({ data, closeModal }: WarningModalProps) => {
  return (
    <Modal
      header="Oops"
      footer={(
        <Button color="primary" onClick={closeModal}>
          I got it
        </Button>
      )}
    >
      <Typography variant="label">{data.message}</Typography>
    </Modal>
  )
}

export default withRenderModal('warning-modal')(WarningModal)
